import { render } from "./MarketingPlan_2.vue?vue&type=template&id=3d3c9248"
import script from "./MarketingPlan_2.vue?vue&type=script&lang=js"
export * from "./MarketingPlan_2.vue?vue&type=script&lang=js"

import "./MarketingPlan_2.vue?vue&type=style&index=0&id=3d3c9248&lang=scss"
script.render = render

export default script